@let isNavigationMenuOpenValue = isNavigationMenuOpen();

<div class="navigation-menu">
  <button
    type="button"
    class="navigation-menu__icon"
    [class.navigation-menu__icon--active]="isNavigationMenuOpenValue"
    [attr.aria-label]="'navigation.toggle-menu' | translate"
    [attr.aria-expanded]="isNavigationMenuOpenValue"
    (click)="toggleNavigationMenu()"
  >
    <i aria-hidden="true" class="fa-solid fa-bars fa--header-texticon"></i>
  </button>

  @if (isNavigationMenuOpenValue) {
    <itc-navigation-menu-panel [(isOpen)]="isNavigationMenuOpen" />
  }
</div>
